import { useEffect } from 'react';

const defaults = {
  title: 'sfretire.com | Experts retraites pour entreprises',
  'og:title': 'sfretire.com - Le savoir ne prend jamais sa retraite',
  'og:description': 'Plateforme de mise en relation entre experts retraites et entreprises. Conseil, mentorat, formation.',
  'og:type': 'website',
  'og:url': 'https://sfretire.com',
  'og:image': 'https://images.unsplash.com/photo-1714974528714-1eaf201fa508?w=1200&q=80',
  'twitter:card': 'summary_large_image',
  'twitter:title': 'sfretire.com - Le savoir ne prend jamais sa retraite',
  'twitter:description': 'Experts retraites pour entreprises. Conseil, mentorat, formation.',
  'twitter:image': 'https://images.unsplash.com/photo-1714974528714-1eaf201fa508?w=1200&q=80',
};

function setMeta(attr, key, value) {
  const el = document.querySelector(`meta[${attr}="${key}"]`);
  if (el) el.setAttribute('content', value);
}

export function useMetaTags(tags) {
  useEffect(() => {
    if (tags.title) document.title = tags.title;

    Object.entries(tags).forEach(([key, value]) => {
      if (key === 'title') return;
      if (key.startsWith('og:') || key.startsWith('article:')) {
        setMeta('property', key, value);
      } else if (key.startsWith('twitter:')) {
        setMeta('name', key, value);
      }
    });

    // Add canonical
    if (tags.canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = tags.canonical;
    }

    return () => {
      document.title = defaults.title;
      Object.entries(defaults).forEach(([key, value]) => {
        if (key === 'title') return;
        if (key.startsWith('og:')) setMeta('property', key, value);
        else if (key.startsWith('twitter:')) setMeta('name', key, value);
      });
      const link = document.querySelector('link[rel="canonical"]');
      if (link) link.remove();
    };
  }, [tags.title]);
}
